import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { FaCopy, FaEye } from "react-icons/fa";
import UserContext from "../context/UserContext";
import PasswordReq from "../components/base/PasswordReq";
import Spinner from "../components/base/Spinner"
import Header from "../components/base/Header";

const Profile = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");

  const { user, updateUser, showPassword, setUser, loading } = useContext(UserContext);

  // Function to ensure that the passwords match
  const confirmPassword = () => {
    if (newPassword !== newPassword2) {
      return false;
    } else {
      return true;
    }
  };

  // Check that the password meets password requirements
  const checkStrength = () => {
    if (newPassword.length > 7) {
      var pattern = new RegExp(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$"
      );

      if (!pattern.test(newPassword)) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  // Function to copy users api key to clipboard
  const copy = () => {
    navigator.clipboard.writeText(user["api_key"]);
    toast.success("API key copied to clipboard!", {
      position: toast.POSITION.TOP_LEFT,
      onOpen: () => {
        let ses = JSON.parse(sessionStorage.getItem("user"));
        sessionStorage.removeItem("user[api_key]");

        delete ses["api_key"];

        sessionStorage.setItem("user", JSON.stringify(ses));

        setUser(ses);
      },
    });
  };

  // Function to call function to call API to update the password
  const submitNewPassword = async (e) => {
    e.preventDefault();

    const confirmedPassword = confirmPassword();

    // Add check for right amount of characters as well and wrap below if statement in another if statement(for different toast errors)
    const passwordStrength = checkStrength();

    if (passwordStrength) {
      // If the passwords match
      if (confirmedPassword) {
        // Create user object to send to API call
        const userObj = {
          name: user["name"],
          last_name: user["last_name"],
          company: user["company"],
          email: user["email"],
          current_password: currentPassword,
          password: newPassword,
        };

        // Call function to call API
        const res = await updateUser(userObj);

        // Reset the form
        setCurrentPassword("");
        setNewPassword("");
        setNewPassword2("");

        if (res.status === 200) {
          toast.success("Password successfully updated!", {
            position: toast.POSITION.TOP_LEFT,
          });
        } else {
          if (res.data.detail[0].msg) {
            toast.error(res.data.detail[0].msg, {
              position: toast.POSITION.TOP_LEFT
            });
          } else {
            toast.error(res.data.detail, {
              position: toast.POSITION.TOP_LEFT
            });
          }
        }
      } else {
        toast.error("Passwords must match");
        setNewPassword2("");
      }
    } else {
      toast.error(
        "Passwords must be atleast 8 characters and contain a capitol letter, a number and a special character."
      );
      setNewPassword("");
      setNewPassword2("");
    }
  };

  // Function to call the function that calls the API to get a new API key
  const getApiKey = async () => {
    // Creating user object for the API
    const userObj = {
      name: user["name"],
      last_name: user["last_name"],
      company: user["company"],
      email: user["email"],
      api_token_request: true,
    };

    // Call function to call the API
    const res = await updateUser(userObj);

    if (res.data) {
      // If the API returns an error
      if (res.data.detail[0]) {
        toast.error(res.data.detail[0].msg, {
          position: toast.POSITION.TOP_LEFT
        });
      } else {
        toast.error(res.data.detail, {
          position: toast.POSITION.TOP_LEFT
        });
      }
    }
  };

  return (
    <main>
      <Header text={"Threat Feed Service"} />
      <div className="boxes">
        <div>
          <div className="box blueBox">
            <p className="boxHeader">User Profile</p>
            <img
              className="threatIcon2"
              src="icons/Threat_feed_icon_2.svg"
              alt="threat feed icon 2"
            />
            <p className="userInfo">
              {user["name"]} {user["last_name"]}
            </p>
            <p className="userInfo">
              {user["company"]}
            </p>
          </div>
          <div className="box">
            <h2>View documentation on how to use the threat feeds API</h2>
            <Link to="/documentation" className="submitBtn">Documentation Page</Link>
          </div>
        </div>
        <div className="box profile">
          <p className="orangeHeader">Manage Profile</p>
          <div className="fieldContainer apiContainer">
            <button className="submitBtn" onClick={() => getApiKey()}>
              Request new API key
            </button>
            {user["api_key"] && (
              <div className="apiKeyContainer">
                <input
                  className="apiInput"
                  name="apiKey"
                  value={user["api_key"]}
                  type="text"
                  disabled
                />
                <FaCopy className="apiCopy" onClick={() => copy()} />
              </div>
            )}
          </div>
          <PasswordReq password={newPassword} />
          <div className="fieldContainer">
            <label className="label" htmlFor="currentPassword">
              Current Password:
            </label>
            <input
              className="input passwordInput passQry"
              name="currentPassword"
              type="password"
              value={currentPassword}
              required
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
            <FaEye className="eye" onClick={() => showPassword()} />
          </div>
          <div className="fieldContainer">
            <label className="label" htmlFor="newPassword">
              New Password:
            </label>
            <input
              className="input passQry"
              name="newPassword"
              type="password"
              value={newPassword}
              required
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className="fieldContainer">
            <label className="label" htmlFor="newPassword2">
              Confirm Password:
            </label>
            <input
              className="input passQry"
              name="newPassword2"
              type="password"
              value={newPassword2}
              required
              onChange={(e) => setNewPassword2(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="submitBtn passwordBtn"
            onClick={(e) => submitNewPassword(e)}
          >
            Change Password
          </button>
        </div>
      </div>
      {loading && <Spinner />}
    </main>
  );
};

export default Profile;
